
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { TYPE_BUTTONS } from '../../../../../constans';
import Button from '../../Button';

const ExportExcelFileButton = ({ data = {}, filename = 'file', columnWidth, buttonTitle = '', style }) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const getSheet = (d) => {
    return XLSX.utils.json_to_sheet(d);
  };
  const exportToCSV = () => {
    const sheetsName = Object.keys(data);

    const excel = {};

    for (let i = 0; i < sheetsName.length; i++) {
      const name = sheetsName[i];
      excel[name] = getSheet(data[sheetsName[i]]);
      if (columnWidth) excel[name]['!cols'] = columnWidth
      console.log(excel, name, sheetsName)
    }

    const wb = { Sheets: excel, SheetNames: sheetsName };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(blob, filename + fileExtension);
  };

  return (
    <Button
      variant="warning"
      type={TYPE_BUTTONS.GREEN}
      stopPropagation={false}
      onClick={(e) => exportToCSV()}
      style={style}
    >
      {buttonTitle}
    </Button>
  );
};


export default ExportExcelFileButton